'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.set = set;
exports.clear = clear;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'banner/SET';
var CLEAR = 'banner/CLEAR';

var initialState = {
  global: {},
  hotel: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var newState = void 0;

  switch (action.type) {
    case SET:
      return (0, _extends3.default)({}, action.banner);
    case CLEAR:
      newState = _lodash2.default.cloneDeep(state);
      newState[action.key] = {};
      return newState;
    default:
      return state;
  }
}

function set(banner) {
  return {
    type: SET,
    banner: banner
  };
}

function clear(key) {
  return {
    type: CLEAR,
    key: key
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/banner.js
// module id = 584
// module chunks = 0